import React from "react";
import { Link } from "react-router-dom";
import { BusinessHeader, BusinessFooter } from "./BusinessHome";

const STEPS = [
  { label: "Customer taps", desc: "NFC sticker or QR code at the table opens your menu instantly in the browser." },
  { label: "They order", desc: "Video menu, modifiers, split bill — no app needed." },
  { label: "Kitchen sees KOT", desc: "Order lands on the KDS in seconds. Chef marks done in one tap." },
  { label: "Served", desc: "Waiter marks served. Customer gets a rating prompt." },
  { label: "You get insights", desc: "Analytics tracks revenue, top items, peak hours, avg rating." },
];

export default function BusinessHowItWorks() {
  return (
    <div className="min-h-screen">
      <BusinessHeader />
      <div className="max-w-3xl mx-auto px-4 py-10">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-brand-dark">How Tabdine works.</h1>
        <p className="text-brand-dark/60 mt-2">The whole loop, from tap to insights.</p>
        <div className="mt-8 space-y-3">
          {STEPS.map((s, i) => (
            <div key={s.label} className="flex gap-4 bg-white rounded-2xl border border-brand-dark/5 p-4">
              <div className="w-9 h-9 rounded-full bg-brand-orange text-white grid place-items-center font-heading font-bold">{i + 1}</div>
              <div>
                <div className="font-heading font-semibold text-brand-dark">{s.label}</div>
                <div className="text-sm text-brand-dark/60 mt-0.5">{s.desc}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-8 text-center">
          <Link to="/business/demo" className="bg-brand-orange text-white px-6 py-3 rounded-full font-medium hover:bg-brand-orange-dark">
            Book a Demo →
          </Link>
        </div>
      </div>
      <BusinessFooter />
    </div>
  );
}
